import { render, staticRenderFns } from "./DashBoard.vue?vue&type=template&id=74031d20&scoped=true&"
import script from "./DashBoard.vue?vue&type=script&lang=js&"
export * from "./DashBoard.vue?vue&type=script&lang=js&"
import style0 from "./DashBoard.vue?vue&type=style&index=0&id=74031d20&lang=scss&scoped=true&"
import style1 from "./DashBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74031d20",
  null
  
)

export default component.exports